import { lazy } from 'react';

// project import
import AuthLayout from 'layout/Auth';
import Loadable from 'components/Loadable';

// render - login
const LoginAuto = Loadable(lazy(() => import('pages/auth/loginAuto')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <AuthLayout />,
      children: [
        {
          path: '/',
          element: <LoginAuto />
        },
        {
          path: 'login',
          element: <LoginAuto />
        }
      ]
    }
  ]
};

export default LoginRoutes;
